const FIFTY_PERCENT_THRESHOLD_INDEX = 5;
const SIXTY_PERCENT_THRESHOLD_INDEX = 9;

export const FIFTY_PERCENT_OCCUPANCY_PERCENTAGE = 0.5;
export const SIXTY_PERCENT_OCCUPANCY_PERCENTAGE = 0.6;
export const SEVENTY_FIVE_PERCENT_OCCUPANCY_PERCENTAGE = 0.75;

export const getOccupancyPercentage = (currentImageIndex: number): number => {
  if (currentImageIndex < FIFTY_PERCENT_THRESHOLD_INDEX)
    return FIFTY_PERCENT_OCCUPANCY_PERCENTAGE;
  if (currentImageIndex < SIXTY_PERCENT_THRESHOLD_INDEX)
    return SIXTY_PERCENT_OCCUPANCY_PERCENTAGE;
  return SEVENTY_FIVE_PERCENT_OCCUPANCY_PERCENTAGE;
};
